import { GroupType } from "./enum/group-type.js"

const GROUP_TYPE_LABELS = {
    [GroupType.ADD]: "Add Tasks",
    [GroupType.OVERWRITE]: "Global Update",
    [GroupType.INTRODUCTION]: "Introduction",
    [GroupType.LEADING_SUMMARY]: "Leading Summary & References",
}

export function getGroupTypeLabel(type) {
    return GROUP_TYPE_LABELS[type] ?? type
}
